import _ from 'lodash';
import commonStrings from '../constants/commonStrings';

// helper functions for payment types, card numbers, etc. Used for visual display of account data

export const getMaskedCardNumber = (result) => {
  if (result.CASH) {
    return 'N/A';
  } else if (result.FRONT_END === 'Recurring' && result.MASKCARDNUMBER) {
    return `************${result.MASKCARDNUMBER.substr(-4)}`;
  } else if (result.CARDTYPE?.toLowerCase() === commonStrings.ach || result.RESPONSECODE === '120') {
    return 'N/A';
  } else if (result.MASKCARDNUMBER) {
    return `************${result.MASKCARDNUMBER.substr(-4)}`;
  } else if (result.CUSTOMERDATA?.masked_card_number) {
    return `************${result.CUSTOMERDATA?.masked_card_number.substr(-4)}`;
  } else {
    return 'N/A';
  }
};

export const getPaymentType = (result) => {
  let type = 'Credit';
  if (
    result.CARDTYPE?.toLowerCase() === commonStrings.ach ||
    result.RESPONSECODE === '120' ||
    result.achDetails?.isOpen
  ) {
    return commonStrings.ach.toUpperCase();
  } else {
    if (result.creditOrDebit !== null && typeof result.creditOrDebit === 'string') {
      type = result.creditOrDebit === 'N/A' ? result.creditOrDebit : _.capitalize(result.creditOrDebit);
    }
  }

  if (result?.CASH) {
    return 'Cash';
  } else {
    return type;
  }
};

export const getCardType = (result) => {
  if (result.CASH) {
    return 'N/A';
  } else if (result.CARDTYPE?.toLowerCase() === commonStrings.ach || result.RESPONSECODE === '120') {
    return commonStrings.ach.toUpperCase();
  } else if (result.CARDTYPE) {
    return result.CARDTYPE;
  } else if (result.CUSTOMERDATA?.cardType) {
    // should be phased out
    return result.CUSTOMERDATA?.cardType;
  } else {
    return 'N/A';
  }
};

export const getCardTypeByFirstDigit = (val) => {
  let number = Number(val);
  switch (number) {
    case 4:
      return commonStrings.visa;
    case 5:
      return commonStrings.masterCard;
    case 3:
      return commonStrings.americanExpress;
    case 6:
      return commonStrings.discoverCard;
    default:
      return commonStrings.ach.toUpperCase();
  }
};

export const getCardTypeByNumber = (cardNumber = '') => {
  let firstNumber = cardNumber?.substring(0, 1);
  switch (firstNumber) {
    case '4':
      return commonStrings.visa;
    case '5':
      return commonStrings.masterCard;
    case '3':
      return commonStrings.americanExpress;
    case '6':
      return commonStrings.discoverCard;
    default:
      return commonStrings.ach.toUpperCase();
  }
};
